RivalIQ.module('suggestion.enums', function (enums, App, Backbone, Marionette, $, _, CompareData) {

    'use strict';

    const msg = enums.message = {};
    msg[CompareData.sources.RIVALIQ] = 'Tell us the display name you want for this company.';
    msg[CompareData.sources.WEB] = 'Tell us the domain you want associated with this company.';
    msg[CompareData.sources.TWITTER] = 'Tell us the Twitter handle you want associated with this company.';
    msg[CompareData.sources.FACEBOOK] = 'Tell us the Facebook page you want associated with this company.';
    msg[CompareData.sources.YOUTUBE] = 'Tell us the YouTube page you want associated with this company.';
    msg[CompareData.sources.INSTAGRAM] = 'Tell us the Instagram page you want associated with this company.';
    msg[CompareData.sources.TIKTOK] = 'Tell us the TikTok handle you want associated with this company.';

    const placeholder = enums.placeholder = {};
    placeholder[CompareData.sources.RIVALIQ] = 'Tell us what you think it should be';
    placeholder[CompareData.sources.WEB] = 'Tell us what you think it should be';
    placeholder[CompareData.sources.TWITTER] = 'https://www.twitter.com/rivaliq';
    placeholder[CompareData.sources.FACEBOOK] = 'https://www.facebook.com/RivalIQ/';
    placeholder[CompareData.sources.YOUTUBE] = 'https://www.youtube.com/channel/UCKb4DMsxVsbS3Z0XgyO0Qrw';
    placeholder[CompareData.sources.INSTAGRAM] = 'https://www.instagram.com/rival_iq/';
    placeholder[CompareData.sources.TIKTOK] = 'https://www.tiktok.com/@rivaliq';

}, RivalIQ.data.CompareData);
